<section [attr.id]="sectionId() || null" [class]="'s__archive-section' + (background() ? ' s__bg-' + background() : '') + (cssClass() ? ' ' + cssClass() : '')">
  <div class="s__archive-section__inner s__container">
  @if (overline()) {
    <ds-overline [text]="overline()" />
  }
  @if (heading()) {
    <h2 class="s__archive-section__heading">{{ heading() }}</h2>
  }
  <!-- Results summary (only shown when filters are available) -->
  @if (!industryCategory() && filterCategories().length > 0) {
    <div class="s__archive-section__results-summary">
      <span>Showing {{ resultCount() }} of {{ totalCount() }} results</span>
      @if (hasActiveFilters()) {
        <button class="s__archive-section__clear-btn" (click)="clearFilters()">Clear filters</button>
      }
    </div>
  }

  @if (industryCategory(); as industry) {
    <!-- Industry-first case-study browsing; other archives retain their existing controls. -->
    <div class="s__archive-section__industry-first">
      <div class="s__archive-section__industry-tabs" role="group" aria-label="Filter by industry">
        <button type="button" class="s__archive-section__industry-tab"
          [attr.aria-pressed]="!selectedFilter(industry.key)"
          (click)="selectFilter(industry.key, '')">All industries</button>
        @for (option of industry.options; track option) {
          <button type="button" class="s__archive-section__industry-tab"
            [attr.aria-pressed]="isFilterActive(industry.key, option)"
            (click)="selectFilter(industry.key, option)">{{ option }}</button>
        }
      </div>
      <label class="s__archive-section__industry-mobile s__archive-section__select-label">
        Industry
        <select class="s__archive-section__select" [value]="selectedFilter(industry.key)"
          (change)="selectFilter(industry.key, $any($event.target).value)">
          <option value="">All industries</option>
          @for (option of industry.options; track option) {
            <option [value]="option">{{ option }}</option>
          }
        </select>
      </label>
      @if (refinementCategories().length > 0) {
        <details class="s__archive-section__refine" [open]="activeRefinementCount() > 0">
          <summary class="s__archive-section__refine-toggle">
            Refine by asset or issue
            @if (activeRefinementCount() > 0) {<span>({{ activeRefinementCount() }})</span>}
          </summary>
          <div class="s__archive-section__refine-fields">
            @for (cat of refinementCategories(); track cat.key) {
              <label class="s__archive-section__select-label">
                {{ filterLabel(cat) }}
                <select class="s__archive-section__select" [value]="selectedFilter(cat.key)"
                  (change)="selectFilter(cat.key, $any($event.target).value)">
                  <option value="">{{ cat.key === 'assetTypes' ? 'All assets' : cat.key === 'faultType' ? 'All issues' : 'All' }}</option>
                  @for (option of availableFilterOptions()[cat.key]; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </label>
            }
          </div>
        </details>
      }
      <div class="s__archive-section__results-summary s__archive-section__results-summary--industry-first">
        <div role="status" aria-live="polite" aria-atomic="true">
          <span>Showing {{ resultCount() }} of {{ totalCount() }} results</span>
          @if (hasActiveFilters()) {
            <span class="s__archive-section__selected-filters">{{ activeFilterSummary() }}</span>
          }
          @if (filterNotice()) {
            <span class="s__archive-section__selected-filters">{{ filterNotice() }}</span>
          }
        </div>
        @if (hasActiveFilters()) {
          <button type="button" class="s__archive-section__clear-btn" (click)="clearFilters()">Clear filters</button>
        }
      </div>
    </div>
  } @else {
  <!-- Filter bar -->
  <div class="s__archive-section__filters">
    @for (cat of enrichedFilterCategories(); track cat.key) {
      @if (cat.options.length > 0) {
      <div class="s__archive-section__filter-group">
        <span class="s__archive-section__filter-label">{{ cat.label }}</span>
        <div class="s__archive-section__filter-tags">
          @for (option of cat.options; track option) {
            <button
              class="s__archive-section__filter-tag"
              [class.s__archive-section__filter-tag--active]="isFilterActive(cat.key, option)"
              (click)="toggleFilter(cat.key, option)"
            >{{ option }}</button>
          }
        </div>
      </div>
      }
    }
  </div>

  }

  <!-- Card grid or empty state -->
  @if (filteredItems().length === 0) {
    <div class="s__archive-section__empty">
      <p>No results match your filters</p>
      <button class="s__archive-section__clear-btn" (click)="clearFilters()">Clear all filters</button>
    </div>
  } @else {
    <div class="s__archive-section__grid">
      @for (item of paginatedItems(); track item.href) {
        <ds-card-item [data]="item.cardData" />
      }
    </div>

    <!-- Pagination -->
    @if (totalPages() > 1) {
      <nav class="s__archive-section__pagination" aria-label="Pagination">
        @if (urlPagination()) {
          @if (currentPage() > 1) {
            <a (click)="$event.stopPropagation()" class="s__archive-section__page-btn" [href]="pageHref(currentPage() - 1)" rel="prev">Previous</a>
          }
          @for (page of pageNumbers(); track page) {
            <a (click)="$event.stopPropagation()" class="s__archive-section__page-btn" [href]="pageHref(page)"
              [class.is-active]="page === currentPage()"
              [attr.aria-current]="page === currentPage() ? 'page' : null">{{ page }}</a>
          }
          @if (currentPage() < totalPages()) {
            <a (click)="$event.stopPropagation()" class="s__archive-section__page-btn" [href]="pageHref(currentPage() + 1)" rel="next">Next</a>
          }
        } @else {
        <button
          class="s__archive-section__page-btn"
          [disabled]="currentPage() <= 1"
          (click)="goToPage(currentPage() - 1)"
        >Previous</button>
        @for (page of pageNumbers(); track page) {
          <button
            class="s__archive-section__page-btn"
            [class.is-active]="page === currentPage()"
            (click)="goToPage(page)"
          >{{ page }}</button>
        }
        <button
          class="s__archive-section__page-btn"
          [disabled]="currentPage() >= totalPages()"
          (click)="goToPage(currentPage() + 1)"
        >Next</button>
        }
      </nav>
    }
  }
  @if (footerHtml()) {
    <div class="s__archive-section__footer s__prose" [innerHTML]="footerHtml()"></div>
  }
  </div>
</section>
